import { Nullable } from '@clearverify/types';

import { AddressInfoFragment } from 'src/api';
import { DroppedFile } from 'src/types/file';

export enum CompanyInformationFormPeoPayrollProviderFields {
  displayName = 'displayName',
  industry = 'industry',
  corporateStructure = 'corporateStructure',
  taxYearEndDate = 'taxYearEndDate',
  numberOfEmployees = 'numberOfEmployees',
  contactPhoneNumber = 'contactPhoneNumber',
  contactEmail = 'contactEmail',
  headquarters = 'headquarters',
  defaultDisclaimer = 'defaultDisclaimer',
  fein = 'fein',
  logoFile = 'logoFile',
}

export type CompanyInformationFormPeoPayrollProviderValues = {
  [CompanyInformationFormPeoPayrollProviderFields.displayName]: Nullable<string>;
  [CompanyInformationFormPeoPayrollProviderFields.industry]: Nullable<string>;
  [CompanyInformationFormPeoPayrollProviderFields.contactEmail]: Nullable<string>;
  [CompanyInformationFormPeoPayrollProviderFields.contactPhoneNumber]: Nullable<string>;
  [CompanyInformationFormPeoPayrollProviderFields.taxYearEndDate]: Nullable<string>;
  [CompanyInformationFormPeoPayrollProviderFields.corporateStructure]: Nullable<string>;
  [CompanyInformationFormPeoPayrollProviderFields.numberOfEmployees]: Nullable<number>;
  [CompanyInformationFormPeoPayrollProviderFields.fein]: Nullable<string>;
  [CompanyInformationFormPeoPayrollProviderFields.defaultDisclaimer]: Nullable<string>;
  [CompanyInformationFormPeoPayrollProviderFields.logoFile]: Nullable<DroppedFile>;
  [CompanyInformationFormPeoPayrollProviderFields.headquarters]: Nullable<
    Omit<AddressInfoFragment, 'id'>
  >;
};
